import { render, staticRenderFns } from "./SideBarLarge.vue?vue&type=template&id=8e296048&scoped=true&"
import script from "./SideBarLarge.vue?vue&type=script&lang=js&"
export * from "./SideBarLarge.vue?vue&type=script&lang=js&"
import style0 from "./SideBarLarge.vue?vue&type=style&index=0&id=8e296048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e296048",
  null
  
)

export default component.exports